import { useMemo } from 'react';
import { collectNodesAndDescendantIds } from 'state/product-description/helper';
import type { ProductNode } from 'state/product-description/model';

import { useCountInvalidFields } from './useCountInvalidFields';

type FieldsNodes = ReadonlyArray<ProductNode> | undefined;

export function useCurrentBlockInvalidFields(children: FieldsNodes) {
  const fieldIds = useMemo(() => Array.from(new Set(collectNodesAndDescendantIds(children))), [children]);
  return useCountInvalidFields([fieldIds])[0];
}
